'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconAsterisk, iconAsteriskTag } from '@ni/nimble-components/dist/esm/icons/asterisk';
import { wrap } from '../../utilities/react-wrapper';

export type { IconAsterisk };
export { iconAsteriskTag };
export const NimbleIconAsterisk = wrap(IconAsterisk);